import { Typography } from "PFComponents/typography/typography";
import NoProfilesIcon from "PFIcons/no_profiles.svg";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./skills_frameworks_empty_page.module.scss";

export const SkillsFrameworksEmptyPage = () => {
  const { t } = useTranslation("skillsFrameworks");

  return (
    <div className={css.container}>
      <NoProfilesIcon className={css.noProfilesIcon} />
      <Typography variant="h5">{t("list.noSkillsFound")}</Typography>
      <Typography variant="bodyRegular">{t("list.createPlease")}</Typography>
    </div>
  );
};
